<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JJQkzI/tc-custom/9780253046925.jpg?1738254646445" alt="This image is the cover for the book Humane Music Education for the Common Good, Counterpoints: Music and Education"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Humane Music Education for the Common Good, Counterpoints: Music and Education
      </h1>
      <p class="bookDescription body article font2">
        <b>Why teach music? Who deserves a music education? Can making and learning about music serve the common good? A collection of essays considers the answers.</b><br/><br/>In <i>Humane Music Education for the Common Good</i>, scholars and educators from around the world offer unique responses to the recent UNESCO report titled <i>Rethinking Education: Toward the Common Good</i>. This report suggests how, through purpose, policy, and pedagogy, education can and must respond to the challenges of our day in ways that respect and nurture all members of the human family.<br/><br/>The contributors use this report as a framework to explore the implications and complexities that it raises. The book begins with analytical reflections on the report and then explores pedagogical case studies and practical models of music education that address social justice, inclusion, individual nurturance, and active involvement in the greater public welfare. The collection concludes by looking to the future, asking what more should be considered, and exploring how these ideals can be even more fully realized. This volume boldly expands the boundaries of the UNESCO report to reveal new ways to think about, be invested in, and use music education as a center for social change both today and going forward.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Iris M. Yob, Estelle R. Jorgensen
      </h2>
      
      <p class="authorDescription body article"><P>Iris M. Yob is Faculty Emerita and Contributing Faculty Member in the Richard W. Riley College of Education and Leadership at Walden University, Minnesota. Estelle R. Jorgensen is Professor Emerita of the Jacobs School of Music at Indiana University and Contributing Faculty Member in the Richard W. Riley College of Education and Leadership at Walden University, Minnesota. She is the author of numerous titles, most recently <I>Pictures of Music Education</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47b66a43